// extracted by mini-css-extract-plugin
export default {"ProductHeader":"ProductHeader_ProductHeader__XLTPt","wordmark":"ProductHeader_wordmark__KxJwn"};